import { v7 as uuidv7 } from 'uuid';

// Идентификатор трассы формата W3C Trace Context: 32 hex-символа. UUIDv7 даёт ровно 128 бит
// с временной упорядоченностью, а снятие дефисов переводит его в требуемую форму.
export function generateTraceId(): string {
  return uuidv7().replace(/-/g, '');
}
